export default __webpack_public_path__ + "static/media/ic_spei_white.705f6077.svg";